import React from 'react'
import CountUp from 'react-countup';
import karnatakaflag from "../assets/Karnataka/Karnatakaflag.png"
import bgImage from "../assets/web-page-3.jpg.webp"

const Counter = () => {
  return (
    <div>
      <div className="relative overflow-hidden bg-none py-[0px] sm:py-8 mx-4 mt-16">
        <div className="hidden lg:block absolute inset-0">
          {/* <div
            className="h-full w-full bg-cover bg-center opacity-100"
            style={{ backgroundImage: `url(${bgImage})` }}
          /> */}
        </div>
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center 2xl:justify-center xl:justify-center md:justify-center lg:justify-center sm:justify-start">
            <div className="flex items-center justify-center mb-2 sm:mb-0">
              <img loading="lazy" decoding="async" src={karnatakaflag} alt="Karnataka Flag" className="h-12 mr-2" width="53" height="45"/>
              <span className="font-poppins tracking-tight text-4xl xl:text-[2.9rem] text-gray-700 2xl:text-[40px] font-semibold">ಕನ್ನಡದ No.1</span>
            </div>
            <span className="font-poppins font-semibold tracking-tight text-4xl xl:text-[2.9rem] text-gray-700 2xl:text-[40px] sm:ml-2 text-center sm:text-left"> Tech-Skilling Platform</span>
          </div>
          <div className="mx-auto mt-4 h-1 w-16 rounded-full bg-[#151595]/80"></div>

          <br className='hidden sm:block'/>
          <br/>
          <dl className="grid grid-cols-1 gap-4 text-center sm:grid-cols-2 lg:grid-cols-4">
            <div className="mx-auto flex w-full max-w-xs flex-col px-6 py-6">
              <dd className='order-first'><i className="fa-solid fa-users text-purple-500 text-5xl"></i></dd>
              <dd className="mt-6 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl"><CountUp end={100000} duration={4} enableScrollSpy scrollSpyOnce /> +</dd>
              <dt className="font-poppins tracking-tight text-base leading-7 text-gray-600">Active Learners</dt>
            </div>
            <div className="mx-auto flex w-full max-w-xs flex-col px-6 py-6">
              <dd className='order-first'><i className="fa-brands fa-youtube text-red-600 text-5xl"></i></dd>
              <dd className="mt-6 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl"><CountUp end={87000} duration={4} enableScrollSpy scrollSpyOnce /> +</dd>
              <dt className="font-poppins tracking-tight text-base leading-7 text-gray-600">YouTube Subscribers</dt>
            </div>
            <div className="mx-auto flex w-full max-w-xs flex-col px-6 py-6">
              <dd className='order-first'><i className="fa-brands fa-instagram text-pink-600 text-5xl"></i></dd>
              <dd className="mt-6 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl"><CountUp end={52000} duration={4} enableScrollSpy scrollSpyOnce /> +</dd>
              <dt className="font-poppins tracking-tight text-base leading-7 text-gray-600">Instagram Followers</dt>
            </div>
            <div className="mx-auto flex w-full max-w-xs flex-col px-6 py-6">
              <dd className='order-first'><i className="fa-brands fa-telegram text-blue-400 text-5xl"></i></dd>
              <dd className="mt-6 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl"><CountUp end={40000} duration={4} enableScrollSpy scrollSpyOnce /> +</dd>
              <dt className="font-poppins tracking-tight text-base leading-7 text-gray-600">Telegram Followers</dt>
            </div>
          </dl>
          <br className='hidden sm:block'/>
          <br/>
          <div className='2xl:text-2xl xl:text-2xl text-md font-poppins tracking-tight leading-7 text-gray-600'>Our Mission: Skill 5 lakh Learners by 2027 <i className="fa-solid fa-medal text-yellow-500"></i></div>
          <br/>
          <a className='hidden sm:block' href="#section4"><button className="tracking-tight font-poppins p-[0.6rem] px-[60px] 2xl:p-[0.6rem] xl:p-[0.9rem] xl:px-[60px] md:p-[1rem] md:px-[90px] 2xl:px-[60px] bg-[#ff0055] text-white text-base md:text-lg xl:text-lg 2xl:text-lg rounded-md shadow-md shadow-red-600/50">Explore Courses <i className="fa-solid fa-angles-right"></i></button></a>
          <div className='sm:hidden space-x-0'>
            <a href="#section4"><button className="font-semibold font-poppins tracking-tight p-3 py-3 px-6 w-full m-4 2xl:ml-0 ml-0 bg-[#ff0055] text-white text-lg rounded-md shadow-md shadow-red-600/50">Explore Courses <i className="fa-solid fa-angles-right"></i></button></a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Counter